import { Grid, Typography } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { SarlaftFormProps } from './props';
import { useSarlaftForm } from './hook';

export const SarlaftForms = (props: SarlaftFormProps) => {
    const { formik } = useSarlaftForm(props);

    return (
        <Grid item xs={12} md={4}>
            <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                Formulario
            </Typography>
            <br />
            <FieldText
                label="Número de formulario"
                name="numberForm"
                size="small"
                required
                onBlur={formik.handleBlur}
                touched={formik.touched.numberForm}
                errors={formik.errors.numberForm}
                value={formik.values.numberForm}
                onChange={formik.handleChange}
            />
        </Grid>
    );
};
